import React from 'react';
import './AddModuleSkeleton.scss';

const AddModuleTableSkeleton = ({ rows = 5 }) => (
    <div className="add-module-skeleton">
        <div className="ams-table">
            <div className="ams-table-header">
                {[...Array(5)].map((_, i) => (
                    <div key={i} className="ams-th" />
                ))}
            </div>
            {[...Array(rows)].map((_, i) => (
                <div key={i} className="ams-table-row">
                    <div className="ams-td ams-td--checkbox" />
                    <div className="ams-td ams-td--thumb" />
                    <div className="ams-td ams-td--title" />
                    <div className="ams-td ams-td--desc" />
                    <div className="ams-td ams-td--type" />
                </div>
            ))}
        </div>
    </div>
);

export default AddModuleTableSkeleton;
